import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedMetierFamilieApiService } from './metier-familie-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class MetierFamilieApiService extends GeneratedMetierFamilieApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
